import { FC } from "react"
import { useSelector } from "react-redux"
import { useUnlockAlarmSound } from "@/components/AudioPlayer/useAutoPlay"
import SnackBar from "@/components/shared/SnackBar"
import { RootState } from "@/store"

export const TAP_TO_ENABLE_SOUND = "Tap anywhere to enable alarm sound"

const AlarmSoundPrompt: FC = () => {
   useUnlockAlarmSound()
   const isSoundEnabled = useSelector(
      ({ audioPlaybackReducer }: RootState) =>
         audioPlaybackReducer.isSoundEnabled
   )

   return (
      <SnackBar
         isOpen={!isSoundEnabled}
         message={TAP_TO_ENABLE_SOUND}
         duration={null}
      />
   )
}

export default AlarmSoundPrompt
